import NoTerminalPage from './NoTerminalPage';

export default NoTerminalPage;
